import { ReactNode } from 'react';
import { CheckboxGroup as AriaCheckboxGroup, Text, FieldError, Label } from 'react-aria-components';
import type { CheckboxGroupProps as AriaCheckboxGroupProps, ValidationResult } from 'react-aria-components';



interface CheckboxGroupProps extends Omit<AriaCheckboxGroupProps, 'children'> {
	children?: ReactNode;
	label?: string;
	description?: string;
	errorMessage?: string | ((validation: ValidationResult) => string);
}


export function CheckboxGroup(props: CheckboxGroupProps) {
	const { label, description, errorMessage, children, ...otherProps } = props;

	return (
		<AriaCheckboxGroup {...otherProps}>
			
			{label &&
				<Label>{label}</Label>}
			
			{children}
			
			{description &&
				<Text slot="description">{description}</Text>}
			
			<FieldError>{errorMessage}</FieldError>
		
		</AriaCheckboxGroup>
	)
}